import { supabaseGetImageUrl } from "lib/supabase";
import React, { useEffect, useState } from "react";

export default function SkillItem({ icon, title, text, link }) {
	const [iconUrl, setIconUrl] = useState("");

	const goToLink = (selectedLink) => {
		window.open(selectedLink, "_blank");
	};

	useEffect(() => {
		async function getIconUrl() {
			const { publicUrl } = await supabaseGetImageUrl(icon);
			setIconUrl(publicUrl);
		}

		getIconUrl();
	}, [icon]);

	return (
		<div
			className="flex flex-row items-center gap-8 bg-white p-6 rounded-xl mb-7 cursor-pointer"
			onClick={() => goToLink(link)}
		>
			<div className="w-[15%]">
				<img className="w-[74px]" src={iconUrl} alt={iconUrl} />
			</div>
			<div className="w-[85%]">
				<div className="text-xl font-medium">{title}</div>
				<div className="text-lg text-gray-500">{text}</div>
			</div>
		</div>
	);
}
